import React from 'react';
import Header from './app/Header';
import Footer from './app/Footer';
import FooterCopyright from './app/FooterCopyright';

// =================================================================
// AVISO INTERNO: contrato-tipo de intermediação de serviços para
// vinculação entre a Fretz / Buzaym Marketing Digital LTDA e os
// ENTREGADORES PARCEIROS autônomos. As cláusulas anti-vínculo
// foram desenhadas conforme a melhor jurisprudência atual, mas
// recomenda-se fortemente revisão por advogado especializado em
// direito do trabalho e direito empresarial antes da publicação
// definitiva. A formalização recomendada é com entregadores
// constituídos como MEI (Microempreendedor Individual).
// =================================================================

const P = ({ children }) => (
  <p className="text-ink-700 leading-relaxed mt-3">{children}</p>
);
const Li = ({ children }) => (
  <li className="text-ink-700 leading-relaxed">{children}</li>
);

const sections = [
  {
    id: 'partes',
    title: '1. Partes',
    render: () => (
      <>
        <P>Pelo presente instrumento, de um lado:</P>
        <P><strong>BUZAYM MARKETING DIGITAL LTDA</strong>, sociedade empresária inscrita no CNPJ sob o nº 49.130.988/0001-00, com sede em Goiânia/GO, doravante denominada <strong>FRETZ</strong>;</P>
        <P>E, de outro lado:</P>
        <P>O <strong>ENTREGADOR PARCEIRO</strong>, profissional autônomo, regularmente cadastrado na PLATAFORMA, identificado pelos dados informados em seu cadastro (nome, CPF, endereço, dados do veículo e demais documentos exigidos), doravante denominado <strong>PARCEIRO</strong>;</P>
        <P>Conjuntamente denominadas <strong>PARTES</strong> e, individualmente, <strong>PARTE</strong>, têm entre si justo e contratado o que segue.</P>
      </>
    ),
  },
  {
    id: 'consideracoes',
    title: '2. Considerações preliminares',
    render: () => (
      <>
        <P>2.1. A FRETZ opera o serviço Fretz Empresas — planos mensais de rota compartilhada com frota identificada para sacolas e pacotes na Grande Goiânia.</P>
        <P>2.2. Este contrato não se destina a marketplace de mudanças, picapes ou caminhões. O objeto são circuitos de pacotes leves (até 40×40×40 cm e 8 kg), com espera máxima de 15 minutos na porta.</P>
        <P>2.3. O PARCEIRO declara ter pleno conhecimento da natureza das rotas e exercer a atividade <strong>por sua livre e espontânea vontade, em nome próprio e por sua conta e risco</strong>, com habitualidade própria de profissional autônomo, salvo se outro regime for pactuado por escrito.</P>
        <P>2.4. As PARTES reconhecem que o presente contrato é regido pelas normas do <strong>direito civil e empresarial</strong>, em especial os arts. 421 e seguintes do Código Civil, não havendo entre elas qualquer vínculo de natureza trabalhista, conforme detalhado na cláusula 4 abaixo.</P>
      </>
    ),
  },
  {
    id: 'objeto',
    title: '3. Objeto',
    render: () => (
      <>
        <P>3.1. Constitui objeto deste contrato:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>a outorga, pela FRETZ ao PARCEIRO, de licença pessoal, não exclusiva, intransferível e revogável de uso da PLATAFORMA para receber, aceitar e executar PEDIDOS de CLIENTES;</Li>
          <Li>a prestação, pela FRETZ ao PARCEIRO, de serviços de intermediação, recebimento e repasse financeiro, bem como de divulgação da disponibilidade do PARCEIRO aos CLIENTES;</Li>
          <Li>a contraprestação devida pelo PARCEIRO à FRETZ, sob a forma de comissão sobre cada PEDIDO efetivamente concluído.</Li>
        </ol>
        <P>3.2. O contrato de transporte propriamente dito é firmado direta e exclusivamente entre o PARCEIRO e o CLIENTE, sem qualquer intervenção, ingerência ou responsabilidade direta da FRETZ por sua execução.</P>
      </>
    ),
  },
  {
    id: 'natureza',
    title: '4. Natureza jurídica autônoma — ausência de vínculo empregatício',
    render: () => (
      <>
        <P>4.1. As PARTES reconhecem expressamente, para todos os fins de direito, que <strong>NÃO existe entre elas qualquer vínculo empregatício</strong>, de subordinação, de exclusividade, de eventualidade, de prepostura, de mandato remunerado, de sociedade de fato ou de qualquer outra natureza além da estrita relação civil/empresarial aqui pactuada.</P>
        <P>4.2. Para evidenciar a autonomia, as PARTES estabelecem que:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li><strong>Liberdade de aceite</strong>: o PARCEIRO é livre para aceitar ou recusar quaisquer PEDIDOS, sem qualquer penalização contratual decorrente de recusa pontual.</Li>
          <Li><strong>Liberdade de jornada</strong>: o PARCEIRO define livremente os dias e horários em que estará disponível na PLATAFORMA, sem cumprimento obrigatório de jornada, controle de ponto, escala ou qualquer modalidade de fiscalização de horário.</Li>
          <Li><strong>Não exclusividade</strong>: o PARCEIRO pode prestar serviços a outras plataformas, empresas ou clientes, ainda que concorrentes, sem qualquer restrição.</Li>
          <Li><strong>Ausência de subordinação</strong>: a FRETZ não dirige, comanda, fiscaliza nem aplica advertências disciplinares ao PARCEIRO. As regras de uso da PLATAFORMA visam apenas à proteção dos CLIENTES e à integridade do serviço, sendo seu descumprimento causa de mera rescisão contratual, e não de penalidade trabalhista.</Li>
          <Li><strong>Onerosidade direta</strong>: o PARCEIRO arca com todos os custos da sua atividade (combustível, manutenção, seguros, equipamentos, dispositivo móvel, dados móveis, vestuário etc.), sendo a remuneração devida exclusivamente em razão de PEDIDOS efetivamente executados.</Li>
          <Li><strong>Habitualidade própria</strong>: o eventual exercício recorrente da atividade pelo PARCEIRO é fruto de sua livre escolha empresarial, característica natural da profissão autônoma de transporte.</Li>
          <Li><strong>Pessoalidade flexibilizada</strong>: a execução é pessoal por imposição regulatória do transporte, mas o PARCEIRO pode interromper, pausar ou cessar a prestação a qualquer tempo.</Li>
        </ol>
        <P>4.3. O PARCEIRO declara expressamente que conhece e aceita o regime jurídico autônomo, reconhecendo que <strong>não faz jus a férias, 13º salário, FGTS, aviso prévio, horas extras, adicional noturno, vale-transporte, vale-alimentação ou quaisquer outras parcelas de natureza trabalhista</strong>.</P>
      </>
    ),
  },
  {
    id: 'cadastro',
    title: '5. Cadastro e documentação',
    render: () => (
      <>
        <P>5.1. Para utilizar a PLATAFORMA, o PARCEIRO deverá apresentar e manter atualizados:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>documento de identidade e CPF;</Li>
          <Li>comprovante de endereço;</Li>
          <Li>Carteira Nacional de Habilitação (CNH) válida e na categoria compatível com o veículo, com a observação "exerce atividade remunerada" (EAR), quando aplicável;</Li>
          <Li>Certificado de Registro e Licenciamento de Veículo (CRLV) atualizado;</Li>
          <Li>autorização de coleta de selfie para validação de identidade.</Li>
        </ol>
        <P>5.2. A FRETZ <strong>recomenda fortemente</strong> que o PARCEIRO se constitua como Microempreendedor Individual (MEI), nos termos da LC 123/2006 e atualizações, atribuindo CNAE compatível com a atividade de transporte (ex.: 5320-2/02 — Serviços de entrega rápida; 4930-2/02 — Transporte rodoviário de carga, exceto produtos perigosos e mudanças, intermunicipal; 5229-0/01 — Serviços de apoio ao transporte por táxi; ou outros aplicáveis).</P>
        <P>5.3. A FRETZ poderá recusar cadastros, suspender ou descredenciar PARCEIROS que não atendam aos requisitos documentais, sem que tal ato configure justa causa, advertência ou penalidade trabalhista.</P>
      </>
    ),
  },
  {
    id: 'veiculo',
    title: '6. Veículo, equipamentos e custeio',
    render: () => (
      <>
        <P>6.1. <strong>Todos os meios necessários</strong> à execução do transporte são de exclusiva responsabilidade e custeio do PARCEIRO, incluindo, sem limitação:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>veículo (motocicleta, automóvel ou outro autorizado), em condições adequadas de uso e segurança;</Li>
          <Li>combustível, manutenção, seguros e impostos do veículo (IPVA, licenciamento, DPVAT);</Li>
          <Li>equipamentos de segurança (capacete certificado, EPIs aplicáveis);</Li>
          <Li>dispositivo móvel (smartphone) com plano de dados;</Li>
          <Li>baú/bag de transporte, quando aplicável.</Li>
        </ol>
        <P>6.2. O PARCEIRO é responsável por contratar, às suas expensas, os seguros que entender necessários para a sua atividade (acidentes pessoais, RCF-V — Responsabilidade Civil Facultativa de Veículos, seguro do veículo etc.).</P>
      </>
    ),
  },
  {
    id: 'tributos',
    title: '7. Tributação e encargos',
    render: () => (
      <>
        <P>7.1. O PARCEIRO é o único e exclusivo responsável pelo recolhimento integral de todos os tributos, contribuições previdenciárias e demais encargos decorrentes de sua atividade autônoma, incluindo, conforme o regime aplicável:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>imposto sobre a renda da pessoa física ou jurídica;</Li>
          <Li>contribuição ao INSS na qualidade de contribuinte individual ou MEI;</Li>
          <Li>ISS, na hipótese de PARCEIRO pessoa jurídica;</Li>
          <Li>DAS-MEI, no caso de microempreendedor individual.</Li>
        </ol>
        <P>7.2. A FRETZ não recolhe, retém ou repassa tributos em nome do PARCEIRO, ressalvadas as hipóteses em que a legislação imponha retenção na fonte. Eventuais retenções determinadas por lei serão informadas no demonstrativo de repasse.</P>
        <P>7.3. O PARCEIRO obriga-se a manter sua situação fiscal e previdenciária regular, indenizando a FRETZ por qualquer prejuízo resultante de descumprimento.</P>
      </>
    ),
  },
  {
    id: 'operacao',
    title: '8. Operação na PLATAFORMA',
    render: () => (
      <>
        <P>8.1. Estando online na PLATAFORMA, o PARCEIRO receberá ofertas de PEDIDOS, podendo aceitá-las ou recusá-las livremente.</P>
        <P>8.2. Ao aceitar um PEDIDO, o PARCEIRO obriga-se a executá-lo com diligência e em conformidade com as informações fornecidas pelo CLIENTE, salvo em hipóteses de risco à sua integridade ou de descumprimento de regras de uso pelo CLIENTE.</P>
        <P>8.3. O PARCEIRO compromete-se, por sua livre adesão a este contrato, a:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>tratar os CLIENTES com civilidade, respeitando a Política de Conduta da PLATAFORMA;</Li>
          <Li>cumprir a legislação de trânsito e as regras de circulação;</Li>
          <Li>não transportar itens proibidos (vide Termos de Uso);</Li>
          <Li>manter a confidencialidade dos dados a que tiver acesso em razão dos PEDIDOS;</Li>
          <Li>não utilizar a PLATAFORMA para finalidade diversa da pactuada.</Li>
        </ol>
        <P>8.4. As regras desta cláusula visam exclusivamente à proteção dos CLIENTES, à integridade da marca FRETZ e à segurança pública, <strong>sem caracterizar comando, controle ou subordinação trabalhista</strong>.</P>
      </>
    ),
  },
  {
    id: 'remuneracao',
    title: '9. Remuneração e comissão',
    render: () => (
      <>
        <P>9.1. Por cada PEDIDO efetivamente concluído (status "entregue"), o CLIENTE pagará à FRETZ o preço integral apresentado no momento da contratação.</P>
        <P>9.2. A FRETZ deduzirá, a título de <strong>comissão de intermediação</strong>, o percentual padrão de <strong>20% (vinte por cento)</strong> sobre o valor de cada PEDIDO, repassando o saldo restante ao PARCEIRO.</P>
        <P>9.3. O percentual de comissão poderá ser alterado pela FRETZ mediante aviso prévio de, no mínimo, <strong>15 (quinze) dias</strong>, comunicado pelos canais oficiais (e-mail, aplicativo). A continuidade do uso da PLATAFORMA após a vigência da alteração caracterizará a aceitação do novo percentual; em caso de desacordo, o PARCEIRO poderá rescindir este contrato unilateralmente, sem ônus.</P>
        <P>9.4. Eventuais descontos contratuais (estornos por não execução, ressarcimentos a CLIENTES decorrentes de avaria por culpa do PARCEIRO, taxas bancárias específicas) serão detalhados no demonstrativo do repasse.</P>
      </>
    ),
  },
  {
    id: 'repasse',
    title: '10. Repasse financeiro',
    render: () => (
      <>
        <P>10.1. A FRETZ atua como mandatária do PARCEIRO para fins exclusivos de recebimento, dos CLIENTES, dos valores devidos pelos PEDIDOS, repassando-os ao PARCEIRO mediante transferência bancária, Pix ou outro meio acordado.</P>
        <P>10.2. O repasse será realizado em ciclos periódicos, conforme rotina financeira da FRETZ, observado o prazo máximo de <strong>30 (trinta) dias</strong> a contar do PEDIDO concluído, podendo ser antecipado a critério da FRETZ.</P>
        <P>10.3. A FRETZ poderá reter cautelarmente repasses correspondentes a PEDIDOS objeto de reclamação fundada de CLIENTE, suspeita de fraude ou estorno, até a apuração dos fatos. A retenção será comunicada ao PARCEIRO, que terá oportunidade de manifestar-se.</P>
        <P>10.4. O PARCEIRO obriga-se a manter atualizada sua chave Pix ou conta bancária para repasse. A FRETZ não responde por atrasos decorrentes de informações incorretas.</P>
      </>
    ),
  },
  {
    id: 'responsabilidades',
    title: '11. Responsabilidade do PARCEIRO',
    render: () => (
      <>
        <P>11.1. O PARCEIRO é integralmente responsável pelos atos praticados durante a execução do CONTRATO DE TRANSPORTE, inclusive por:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>danos causados ao CLIENTE, à encomenda, a terceiros ou ao patrimônio público no curso do transporte;</Li>
          <Li>infrações de trânsito;</Li>
          <Li>perda, extravio, avaria ou furto da encomenda enquanto sob sua posse, observados os limites contratuais;</Li>
          <Li>tributos próprios da atividade autônoma.</Li>
        </ol>
        <P>11.2. O PARCEIRO obriga-se a indenizar a FRETZ contra toda e qualquer reclamação, ação, perda, dano ou despesa (inclusive honorários advocatícios) que ela venha a sofrer em razão de ato ou omissão atribuível ao PARCEIRO, ressalvada a hipótese de culpa exclusiva da FRETZ.</P>
      </>
    ),
  },
  {
    id: 'suspensao',
    title: '12. Suspensão e descredenciamento',
    render: () => (
      <>
        <P>12.1. A FRETZ poderá suspender ou descredenciar o PARCEIRO, a seu critério, nas seguintes hipóteses:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>descumprimento deste contrato, dos Termos de Uso ou da Política de Privacidade;</Li>
          <Li>fornecimento de informações falsas ou irregularidade documental;</Li>
          <Li>prática de atos ilícitos, fraudes, agressão, assédio ou discriminação;</Li>
          <Li>reiteração de cancelamentos imotivados ou avaliações negativas graves;</Li>
          <Li>desatualização documental persistente após notificação.</Li>
        </ol>
        <P>12.2. A suspensão e o descredenciamento são medidas <strong>contratuais</strong>, decorrentes do exercício regular do direito de não contratar previsto no art. 421 do Código Civil, e <strong>não constituem advertência ou justa causa</strong> de natureza trabalhista.</P>
        <P>12.3. Os valores de PEDIDOS já concluídos pelo PARCEIRO antes da suspensão serão integralmente repassados, observado o ciclo de repasse vigente.</P>
      </>
    ),
  },
  {
    id: 'sigilo',
    title: '13. Confidencialidade e LGPD',
    render: () => (
      <>
        <P>13.1. O PARCEIRO obriga-se a manter sob sigilo absoluto todos os dados pessoais de CLIENTES e demais informações a que tiver acesso em razão dos PEDIDOS, sob pena de descredenciamento e responsabilização civil e criminal.</P>
        <P>13.2. O PARCEIRO declara conhecer e cumprir a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), atuando como <strong>operador autônomo</strong> dos dados estritamente necessários à execução do PEDIDO.</P>
        <P>13.3. É expressamente vedado ao PARCEIRO:</P>
        <ol className="list-decimal pl-6 mt-3 space-y-2">
          <Li>registrar, copiar ou armazenar dados de CLIENTES fora dos canais oficiais da PLATAFORMA;</Li>
          <Li>contatar CLIENTES para fins não relacionados ao PEDIDO em curso;</Li>
          <Li>utilizar dados de CLIENTES para divulgação, marketing próprio ou venda;</Li>
          <Li>compartilhar dados com terceiros.</Li>
        </ol>
      </>
    ),
  },
  {
    id: 'vigencia',
    title: '14. Vigência e rescisão',
    render: () => (
      <>
        <P>14.1. Este contrato vigora por prazo indeterminado, a partir da aceitação eletrônica pelo PARCEIRO no momento do cadastro.</P>
        <P>14.2. Qualquer das PARTES pode rescindir o contrato, a qualquer tempo, mediante simples comunicação escrita à outra (incluindo e-mail aos canais oficiais), <strong>sem ônus, multa ou aviso prévio</strong>, ressalvado o cumprimento das obrigações pendentes (especialmente o repasse financeiro).</P>
        <P>14.3. A rescisão não prejudica direitos adquiridos ou a exigibilidade de obrigações já constituídas até a data da extinção.</P>
      </>
    ),
  },
  {
    id: 'gerais',
    title: '15. Disposições gerais',
    render: () => (
      <>
        <P>15.1. As alterações deste contrato serão comunicadas por escrito ao PARCEIRO, com antecedência mínima de 15 (quinze) dias. A continuidade no uso da PLATAFORMA após a vigência caracterizará aceitação tácita.</P>
        <P>15.2. A tolerância da FRETZ ao descumprimento de qualquer cláusula não importa em renúncia, novação ou alteração do pactuado.</P>
        <P>15.3. A nulidade de uma cláusula não afeta a validade das demais.</P>
        <P>15.4. Este contrato representa o acordo integral entre as PARTES quanto ao seu objeto.</P>
      </>
    ),
  },
  {
    id: 'foro',
    title: '16. Foro e legislação aplicável',
    render: () => (
      <>
        <P>16.1. Este contrato é regido pela legislação brasileira, em especial pelo Código Civil.</P>
        <P>16.2. Fica eleito o foro da Comarca de <strong>Goiânia/GO</strong> para dirimir quaisquer controvérsias decorrentes deste instrumento, com renúncia a qualquer outro, por mais privilegiado que seja.</P>
        <P>16.3. As PARTES comprometem-se a buscar, antes de qualquer medida judicial, a solução amigável de conflitos pelos canais oficiais da FRETZ.</P>
      </>
    ),
  },
  {
    id: 'aceite',
    title: '17. Aceite eletrônico',
    render: () => (
      <>
        <P>17.1. O PARCEIRO declara, mediante aceite eletrônico no momento do cadastro, que leu, compreendeu e concorda integralmente com o presente contrato, tendo sido informado de todas as suas cláusulas, em especial as relativas à <strong>natureza autônoma da relação</strong> (cláusula 4) e à <strong>responsabilidade pessoal pela execução do transporte</strong> (cláusula 11).</P>
        <P>17.2. O registro do aceite, a data, o IP e demais metadados são preservados pela FRETZ como prova do consentimento informado, nos termos do art. 10 da MP 2.200-2/2001.</P>
      </>
    ),
  },
];

const ContratoIntermediacao = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 bg-mesh-light opacity-60" aria-hidden="true" />
        <div className="relative container mx-auto px-4 lg:px-6 py-16 lg:py-24 max-w-3xl">
          <span className="badge-brand mb-5">Documento legal</span>
          <h1 className="font-display text-display-lg text-ink-900">
            Contrato de Intermediação de Serviços
          </h1>
          <p className="mt-3 text-ink-500">
            Vigente a partir de 01 de maio de 2026 · Versão 2.0
          </p>

          <div className="mt-8 p-5 rounded-2xl bg-brand-50 border border-brand-100">
            <p className="text-sm text-ink-700 leading-relaxed">
              <strong>Resumo</strong>: este contrato disciplina a relação entre
              a FRETZ (Buzaym Marketing Digital LTDA) e o MOTORISTA DE ROTA,
              que atua nos circuitos da frota identificada Fretz Empresas
              (planos Diário, Semanal e Mensal) na Grande Goiânia. A relação é
              estritamente civil/empresarial — não há vínculo empregatício,
              jornada, exclusividade ou subordinação, salvo se outro instrumento
              for firmado. Pacotes leves (até 40×40×40 cm e 8 kg); espera na
              porta limitada a 15 minutos. Foro: Goiânia/GO.
            </p>
          </div>

          <div className="mt-10 space-y-10">
            {sections.map((s) => (
              <section key={s.id} id={s.id}>
                <h2 className="font-display text-xl font-bold text-ink-900">{s.title}</h2>
                {s.render()}
              </section>
            ))}
          </div>

          <div className="mt-12 p-6 rounded-2xl bg-ink-50 border border-ink-100">
            <p className="text-sm text-ink-600 leading-relaxed">
              <strong>BUZAYM MARKETING DIGITAL LTDA</strong> · CNPJ 49.130.988/0001-00<br />
              Goiânia/GO · contato@fretz.com.br · privacidade@fretz.com.br
            </p>
          </div>
        </div>
      </section>

      <Footer />
      <FooterCopyright />
    </div>
  );
};

export default ContratoIntermediacao;
